export default __webpack_public_path__ + "static/media/evo-icon.0a68972a.svg";